import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Geometry from './Geometry';
import GeometryCollection from './GeometryCollection';
import Dimension from './Dimension';
import Puntal from './Puntal';
var MultiPoint = /*#__PURE__*/function (_GeometryCollection) {
  _inherits(MultiPoint, _GeometryCollection);
  function MultiPoint() {
    var _this;
    _classCallCheck(this, MultiPoint);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiPoint).call(this));
    MultiPoint.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(MultiPoint, [{
    key: "copyInternal",
    value: function copyInternal() {
      var points = new Array(this._geometries.length).fill(null);
      for (var i = 0; i < points.length; i++) points[i] = this._geometries[i].copy();
      return new MultiPoint(points, this._factory);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return true;
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0],
          tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) return false;
        return _get(_getPrototypeOf(MultiPoint.prototype), "equalsExact", this).call(this, other, tolerance);
      } else {
        return _get(_getPrototypeOf(MultiPoint.prototype), "equalsExact", this).apply(this, arguments);
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 1 && Number.isInteger(arguments[0])) {
        var n = arguments[0];
        return this._geometries[n].getCoordinate();
      } else {
        return _get(_getPrototypeOf(MultiPoint.prototype), "getCoordinate", this).apply(this, arguments);
      }
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return Dimension.FALSE;
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_MULTIPOINT;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 0;
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      return this.getFactory().createGeometryCollection();
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_MULTIPOINT;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Puntal];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      var points = arguments[0],
        factory = arguments[1];
      GeometryCollection.constructor_.call(this, points, factory);
    }
  }]);
  return MultiPoint;
}(GeometryCollection);
export { MultiPoint as default };